<mat-card>
  <mat-card-title>Je laisse un message sur WikiP8</mat-card-title>
  <mat-card-content>
    <div fxFlex="100">
      <mat-form-field fxFlex="100" [appearance]="'outline'" [floatLabel]="'never'">
        <label>
          <textarea matInput
                    matTextareaAutosize
                    matAutosizeMinRows="3"
                    placeholder="Votre commentaire sur WikiP8, au moins 20 caractères"
                    [(ngModel)]="commentText"
                    name="comment">
            </textarea>
        </label>
        <mat-hint align="end" *ngIf="commentText"><code>{{commentText.length}}</code></mat-hint>
      </mat-form-field>

    </div>
  </mat-card-content>
  <mat-card-actions [align]="'end'">
    <button mat-raised-button
            type="submit"
            color="accent"
            (click)="saveComment()"
            [disabled]="! (commentText && commentText.length > 20)"
            matTooltip="Envoyer votre message"
    >ENVOYER</button>
  </mat-card-actions>
</mat-card>
